export async function call (config) {
    $('.is-invalid').removeClass('is-invalid');

    if (!config.background) {
        config.form.mask();
    }

    let axiosResponse;
    let axiosStatus;

    await axios(config).then(function (response) {
        toastr.success(response.data.message ? response.data.message : translator.record_updated);
        axiosResponse            = response.data;
        axiosResponse.statusCode = response.status;
        axiosStatus              = response.status;
    }).catch(function (error) {
        toastr.error(translator.ajax_error_issue + '<br>' + error.response.data.message);
        $.each(error.response.data.errors, function (field, error) {
            if ($('input[name="' + field + '"]').length) {
                $('input[name="' + field + '"]').addClass('is-invalid');
                if ($('input[name="' + field + '"]').closest('.flatpickr-wrapper').length) {
                    $('input[name="' + field + '"]').closest('.flatpickr-wrapper').addClass('is-invalid');
                } else if ($('input[name="' + field + '"]').closest('.psa-material').length) {
                    $('input[name="' + field + '"]').closest('.psa-material').addClass('is-invalid');
                }
            } else if ($('select[name="' + field + '"]').length) {
                $('select[name="' + field + '"]').addClass('is-invalid');
                if ($('select[name="' + field + '"]').closest('.psa-material').length) {
                    $('select[name="' + field + '"]').closest('.psa-material').addClass('is-invalid');
                } else if ($('select[name="' + field + '"]').closest('.bootstrap-select').length) {
                    $('select[name="' + field + '"]').closest('.bootstrap-select').addClass('is-invalid')
                } else if ($('select[name="' + field + '[]"]').closest('.bootstrap-select').length) {
                    $('select[name="' + field + '[]"]').closest('.bootstrap-select').addClass('is-invalid')
                }
            } else if ($('select[name="' + field + '[]"]').length) {
                $('select[name="' + field + '[]"]').addClass('is-invalid');
                if ($('select[name="' + field + '[]"]').closest('.bootstrap-select').length) {
                    $('select[name="' + field + '[]"]').closest('.bootstrap-select').addClass('is-invalid')
                }
            } else if ($('input[name="' + field + '[]"]').length) {
                $('input[name="' + field + '[]"]').addClass('is-invalid');
                if ($('input[name="' + field + '[]"]').closest('.psa-material').length) {
                    $('input[name="' + field + '[]"]').closest('.psa-material').addClass('is-invalid');
                }
            } else if ($('textarea[name="' + field + '"]').length) {
                $('textarea[name="' + field + '"]').addClass('is-invalid')
            } else {

                let parts           = field.split('.');
                let bracketNotation = parts[0];
                for (let i = 1; i < parts.length; i++) {
                    bracketNotation += `[${parts[i]}]`;
                }
                let escapedFieldName = bracketNotation.replace(/(\[|\])/g, '\\$1');

                let inputElement = $(`[name="${escapedFieldName}"]`);

                if (inputElement.length === 0 && parts.length > 1) {
                    let generalizedName        = `${parts[0]}[]`;
                    let escapedGeneralizedName = generalizedName.replace(/(\[|\])/g, '\\$1');
                    let inputElements          = $(`[name="${escapedGeneralizedName}"]`);

                    if (inputElements.length > 0) {
                        let index = parseInt(parts[1], 10);
                        if (!isNaN(index) && inputElements[index]) {
                            inputElement = $(inputElements[index]);
                        }
                    }
                }

                if (inputElement.length > 0) {
                    inputElement.addClass('is-invalid');
                    if (inputElement.closest('.flatpickr-wrapper').length) {
                        inputElement.closest('.flatpickr-wrapper').addClass('is-invalid');
                    } else if (inputElement.closest('.psa-material').length) {
                        inputElement.closest('.psa-material').addClass('is-invalid');
                    } else if (inputElement.closest('.psa-material').length) {
                        inputElement.closest('.psa-material').addClass('is-invalid');
                    } else if (inputElement.closest('.bootstrap-select').length) {
                        inputElement.closest('.bootstrap-select').addClass('is-invalid');
                    } else if (inputElement.closest('.bootstrap-select').length) {
                        inputElement.closest('.bootstrap-select').addClass('is-invalid');
                    } else if (inputElement.closest('.bootstrap-select').length) {
                        inputElement.closest('.bootstrap-select').addClass('is-invalid');
                    }

                }
            }
        });
        axiosResponse = false;
        axiosStatus   = error.response.status;
    }).then(function () {
        if (!config.background) {
            config.form.unmask();
        }

        var callback = config.form.data('callback');
        if (callback) {
            window[callback](axiosStatus, axiosResponse);
        }
    });

    return axiosResponse;
}
